import { render, staticRenderFns } from "./DomainsDelete.vue?vue&type=template&id=188e524c&scoped=true"
import script from "./DomainsDelete.vue?vue&type=script&lang=js"
export * from "./DomainsDelete.vue?vue&type=script&lang=js"
import style0 from "./DomainsDelete.vue?vue&type=style&index=0&id=188e524c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e524c",
  null
  
)

export default component.exports